import { COLOURS, STRING } from 'resources'

import { SectionTitle, ColorDisplayContainer, ColorDisplay } from './styles'

const ColoursSection = () => (
  <>
    <SectionTitle>{STRING.designSystemScreen.colours}</SectionTitle>
    <ColorDisplayContainer>
      <ColorDisplay color={COLOURS.primaryYellow} />
      <ColorDisplay color={COLOURS.primaryBlue} />
    </ColorDisplayContainer>
    <ColorDisplayContainer>
      <ColorDisplay color={COLOURS.secondaryRed1} />
      <ColorDisplay color={COLOURS.secondaryRed2} />
      <ColorDisplay color={COLOURS.secondaryPurple1} />
      <ColorDisplay color={COLOURS.secondaryPurple2} />
    </ColorDisplayContainer>
    <ColorDisplayContainer>
      <ColorDisplay color={COLOURS.neutralBlack} />
      <ColorDisplay color={COLOURS.neutralWhite} />
      <ColorDisplay color={COLOURS.neutralGrey1} />
      <ColorDisplay color={COLOURS.neutralGrey2} />
      <ColorDisplay color={COLOURS.neutralGrey3} />
      <ColorDisplay color={COLOURS.neutralGrey4} />
      <ColorDisplay color={COLOURS.neutralGrey5} />
    </ColorDisplayContainer>
    <ColorDisplayContainer>
      <ColorDisplay color={COLOURS.systemYellow1} />
      <ColorDisplay color={COLOURS.systemYellow2} />
      <ColorDisplay color={COLOURS.systemOrange1} />
      <ColorDisplay color={COLOURS.systemOrange2} />
      <ColorDisplay color={COLOURS.systemGreen1} />
      <ColorDisplay color={COLOURS.systemGreen2} />
    </ColorDisplayContainer>
  </>
)

export default ColoursSection
